// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
const { getContentFormContainer } =
  require("../../manage/methods/ContentFormUtils").default
const { TASK } = require("./ManageCompletionConfig").default

export const task = {
  icon: "check-dash-square",
  title: "Add a to-do",
  prompt: "A discussion, task, anything,...",
  form: getContentFormContainer(TASK)
}
